import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsBoardsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Boards</div>
          <div className="text">
            Boards are the high-level objects where your users can post and vote on ideas for a
            specific topic, typically feature requests. The API allows you to fetch a specific
            board, or a list of all boards for your&nbsp;company.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
